import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { HttpCode } from 'types';
import { HttpError } from 'utils/http-error';
import { StoreDetail } from 'features/store/types';
import { getStoreById } from './api';

type InitialState = {
  data: StoreDetail | null;
  errorCode: HttpCode | null;
  isError: boolean;
};

const initialState: InitialState = {
  data: null,
  errorCode: null,
  isError: false,
};

const fetchStoreByIdThunk = createAsyncThunk('storeById/FETCH_STORE_DETAIL', getStoreById);

const { actions, reducer } = createSlice({
  name: 'storeDetail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStoreByIdThunk.pending, (state) => {
        state.data = null;
        state.isError = false;
        state.errorCode = null;
      })
      .addCase(fetchStoreByIdThunk.fulfilled, (state, { payload }) => {
        state.data = payload as StoreDetail;
        state.isError = false;
        state.errorCode = null;
      })
      .addCase(fetchStoreByIdThunk.rejected, (state, { payload }) => {
        state.data = null;
        state.isError = true;
        state.errorCode = payload as HttpCode;
        throw new HttpError(payload as HttpCode);
      });
  },
});

export { actions, reducer, fetchStoreByIdThunk };
